export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <span className="footer-copy">
          © {new Date().getFullYear()} Tingis K — all rights reserved
        </span>
        <div className="footer-links">
          <a href="#top">Back to top</a>
          <a href="#work">Work</a>
          <a href="#contact">Contact</a>
        </div>
      </div>
    </footer>
  );
};
